import type { Color } from '../types/color';

/** Determines if color (usually background) is above a certain threshold to be considered "dark"
 *
 * @param color - The color to check
 * @returns { boolean } true if the color value index is 60 or above
 */

const isDark = (color: Color.ValueKeys) => Number(color.split('.')[1]) >= 60;

export default isDark;
